import React, {useState, useEffect} from 'react';

import {isEmptyObj} from 'ultra/helpers/utils';

import Grid from '@mui/material/Grid';

// import Currencies from './Currencies'

import './index.scss'

export default (props) => {
    const {partner, product, widget, type, widgetData, onSubmitCallback} = props;

    const [Widget, setWidget] = useState(null);

    const Templates = {
        // currencies: Currencies,
    }

    useEffect(() => {
        if (widget && !isEmptyObj(widget)) {
            if (typeof Templates[widget.id] !== 'undefined') {
                setWidget(() => React.createElement(
                    Templates[widget.id],
                    {
                        widget,
                        type,
                        data: widgetData,
                        partner,
                        product,
                        onSubmitCallback
                    }
                ));
            } else {
                setWidget(React.createElement(
                    () => <div>{widget.id} widget has not been created yet</div>
                ));
            }
        }
    }, [widget])

    return <Grid container spacing={2}>
        <Grid item xs={12}>
            {Widget}
        </Grid>
    </Grid>
}
